import React from 'react';

type IconProps = {
  className?: string;
};
const UserGraduate: React.FC<IconProps> = props => <div />;
export default UserGraduate;
